export default __webpack_public_path__ + "static/media/tru-logo-white.29dbb6ee.svg";